import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Popup from 'components/Popup';
import ReadMore from 'components/Buttons/ReadMore';

export default function QSBSPopups({ isQSBSPopupOpen, setIsQSBSPopupOpen }) {
  const [isReadMorePopupOpen, setIsReadMorePopupOpen] = useState(false);

  const closeQSBSPopup = () => setIsQSBSPopupOpen(false);
  const closeReadMorePopup = () => setIsReadMorePopupOpen(false);

  const switchPopups = () => {
    closeQSBSPopup();
    setIsReadMorePopupOpen(true);
  };

  return (
    <>
      {isQSBSPopupOpen && (
        <Popup closePopup={closeQSBSPopup}>
          <div className='mb-5'>
            <h2 className='mb-4'>What is QSBS?</h2>
            <p>Under Section 1202 of the Internal Revenue Code (IRC), individuals are allowed to invest in small business.</p>
          </div>
          <div>
            <ReadMore onClick={switchPopups} />
          </div>
        </Popup>
      )}

      {isReadMorePopupOpen && (
        <Popup closePopup={closeReadMorePopup}>
          <h2 className='mb-4'>What is QSBS?</h2>
          <p>Under Section 1202 of the Internal Revenue Code (IRC), individuals are allowed to invest in small businesses.</p>
          <p>
            Small businesses that qualify as a QSB (qualified small business) are any domestic C corporations whose assets are under $50
            million.
          </p>
          <p>
            QSBS (qualified small business stock) are stocks acquired from QSB. The capital gains from the sale of QSBS are exempt from
            federal taxes and also benefit from favorable tax treatment if they meet the QSBS exclusion:
          </p>

          <ul>
            <li>You’ve held the stock for at least five years and you are a non-corporate taxpayer.</li>
            <li>Stocks exercised were issued after August 10, 1993.</li>
            <li>
              The company issuing the stocks is a domestic C corporation with no more than $50 million in gross assets at the moment when
              the stock was issued.
            </li>
            <li>The company issuing stocks uses at least 80% of its assets in active trades or their business operations.</li>
          </ul>

          <p>For more information on QSBS, consult with a tax advisor or refer to Section 1202 of the IRS Code.</p>
        </Popup>
      )}
    </>
  );
}

QSBSPopups.propTypes = {
  isQSBSPopupOpen: PropTypes.bool,
  setIsQSBSPopupOpen: PropTypes.func
};
